export default "__VITE_PUBLIC_ASSET__4211c195__"